import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import isInPlanWorkoutUtil from '../../../../../modules/workout/model/utils/is-in-plan'

import updateLocalHasAssociationChangePlanAction from '../../../../plans/actions/update-local-has-association-change'
import cloneIfCantEditWorkoutAction from '../clone-if-cant-edit'
import updateWorkoutAction from '../update'
import WORKOUTS_ACTION from '../../constants/action'

function updateLocalHasAssociationChangeWorkoutAction (params = {}) {
  return async (dispatch) => {
    dispatch(updateWorkoutAction({
      type: WORKOUTS_ACTION.UPDATE_LOCAL_HAS_ASSOCIATION_CHANGE,
      payload: {
        key: WORKOUT_KEY.LOCAL_HAS_ASSOCIATION_CHANGE,
        value: true
      }
    }))

    if (params.shouldKeepWorkoutRecommended) {
      return
    }

    const workout = await dispatch(cloneIfCantEditWorkoutAction())

    // If it's in a plan, update it
    if (isInPlanWorkoutUtil(workout)) {
      dispatch(updateLocalHasAssociationChangePlanAction())
    }
  }
}

export default updateLocalHasAssociationChangeWorkoutAction
